import { type ReactNode } from 'react'

export interface FormRadioButtonCircle {
  children: ReactNode
  disabled?: boolean
  value?: string
  onClick?: () => void
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  inputName: string
  description?: string
  labelClass?: string
  wrapperClass?: string
  style?: number
  wrapperLabelClassName?: string
  checked?: boolean
}

export function FormRadioButtonCircle({
  children,
  onClick = () => true,
  onChange,
  inputName,
  description,
  value,
  labelClass,
  checked,
  disabled,
  style = 1,
  wrapperClass,
  wrapperLabelClassName,
}: FormRadioButtonCircle) {
  return (
    <div
      className={`mb-[30px] pb-[30px] ${wrapperClass && wrapperClass} ${
        style === 1 ? 'border-b border-[#BDBDBD]' : 'form-check-default w-full'
      } `}
    >
      <div
        className={`flex items-center ${disabled ? 'cursor-not-allowed' : ''}`}
      >
        <input
          type='radio'
          onClick={onClick}
          onChange={onChange}
          className={`${
            style === 1
              ? 'mr-[10px] h-[20px] w-[20px] text-[#111111] accent-border-primary focus:shadow-none focus:outline-none focus:ring-0'
              : 'form-radio-input'
          }`}
          id={value}
          name={inputName}
          value={value}
          checked={checked}
          disabled={disabled}
        />
        <label
          htmlFor={value}
          className={`${
            style === 1 ? 'text-[14px] leading-[20px]' : 'form-radio-label'
          } ${labelClass && labelClass}`}
        >
          {children}
        </label>
      </div>
      {description && (
        <div className={`ml-[32px] mt-[12px] ${wrapperLabelClassName}`}>
          <label
            htmlFor={value}
            className='font-openSans text-[16px] font-[390] leading-[22px]'
          >
            {description}
          </label>
        </div>
      )}
    </div>
  )
}

export default FormRadioButtonCircle
